// The notch is a downward "dip" cut into the top edge of the bottom-nav bar,
// cradling the raised circle of the active item. The bar is authored in a
// fixed 428×75 viewBox; only the horizontal position of the dip changes.
//
// `buildNotchPath(cx)` returns the full bar outline with the dip centred at
// `cx` (viewBox units). The dip half-width is 61 and its curve offsets are
// taken verbatim from the original hand-drawn artwork, so the shape is
// pixel-identical to the design — we only slide it horizontally so it sits
// exactly under whichever item is active (its centre is measured at runtime).

export const NOTCH_DIP_HALF_WIDTH = 61;
// Keep the dip fully inside the bar's rounded corners: cx-61 >= 12 (left
// corner) and cx+61 <= 416 (right corner).
export const NOTCH_MIN_CENTER = 73;
export const NOTCH_MAX_CENTER = 355;

export const clampNotchCenter = (cx: number): number =>
  Math.max(NOTCH_MIN_CENTER, Math.min(NOTCH_MAX_CENTER, cx));

const f = (n: number): string => Number(n.toFixed(3)).toString();

export function buildNotchPath(centerX: number): string {
  const cx = clampNotchCenter(centerX);
  return (
    "M416 0C422.627 0 428 5.373 428 12V49C428 63.359 416.359 75 402 75H26" +
    "C11.641 75 0 63.359 0 49V12C0 5.373 5.373 0 12 0" +
    `H${f(cx - 61)}` +
    `C${f(cx - 46.641)} 0 ${f(cx - 35.495)} 13.099 ${f(cx - 25.78)} 23.673` +
    `C${f(cx - 19.383)} 30.636 ${f(cx - 10.201)} 35 ${f(cx)} 35` +
    `C${f(cx + 10.201)} 35 ${f(cx + 19.383)} 30.636 ${f(cx + 25.78)} 23.673` +
    `C${f(cx + 35.495)} 13.099 ${f(cx + 46.641)} 0 ${f(cx + 61)} 0` +
    "H416Z"
  );
}
